import {useQuery} from 'react-query';
import {client} from './ApiClient';
import {mapServiceUrls} from '../Helpers/Functions';

const getEGiftCartLine = (urls: any, domain: string, deviceCode: string, cartUid: string, lineUid: string, productCode: string) => {
	const params = new URLSearchParams({cartUid})
	if (lineUid)
		params.append('lineUid', lineUid)
	if (productCode)
		params.append('productCode', productCode)
	return client(urls.LoyaltyEngineApiUrl, `api/v4/${domain}/${deviceCode}/carts/egiftline?${params.toString()}`);
}

// eGiftLine is undefined until loaded, then the cart's eGift line or null when the cart has none.
export default function useGetEGiftCartLine(urls: any, domain: string, deviceCode: string, cartUid: string, lineUid: string, productCode: string) {
	const {status, data, error} = useQuery(['EGiftCartLine', cartUid, lineUid, productCode], () => getEGiftCartLine(mapServiceUrls(urls), domain, deviceCode, cartUid, lineUid, productCode), { enabled: urls && !!cartUid, staleTime: 1000*60*60 });
	const eGiftLine = data ? data.data?.Line ?? null : undefined;
	return {lineStatus: status, eGiftLine, lineError: error};
}
